import {
  ensurePuzzelAuthenticated,
  redirectToPuzzelLogin,
} from "app/PuzzelAuth/puzzelAuth";
import {
  getPuzzelCustomerKey,
  resetPuzzelLoginAttempts,
} from "app/PuzzelAuth/puzzelTokenStorage";
import axios from "axios";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { devLog } from "shared/utils/devLog";

const PUZZEL_BASE_URL = "https://api.puzzel.com/ContactCentre5/";

const puzzelHttpClient = axios.create();
const logSource = "puzzelHttpClient";

puzzelHttpClient.interceptors.request.use(async (config) => {
  const accessToken = await ensurePuzzelAuthenticated();
  // Customer key comes from the access token's "urn:puzzel:cc:slid" claim (see savePuzzelTokens).
  // eslint-disable-next-line no-param-reassign -- Interceptor function
  config.url = `${PUZZEL_BASE_URL + getPuzzelCustomerKey()}/${config.url}`;
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

puzzelHttpClient.interceptors.response.use(
  (response) => {
    // Proves the token isn't just present but actually valid/authorized for this API.
    resetPuzzelLoginAttempts();
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      // Token rejected without being locally expired - retry via fresh login; throws instead of
      // looping forever once the attempt budget runs out.
      await redirectToPuzzelLogin();
      return new Promise(() => {});
    }
    // Response body may contain call-center customer data (phone numbers, names) - devLog only.
    devLog(
      LogLevel.error,
      logSource,
      "Puzzel API error response body",
      error.response?.data,
    );
    log(
      LogLevel.error,
      logSource,
      `Call to ${error.response?.request?.responseURL} failed with status ${error.response?.status}: ${error.message}`,
    );
    return error;
  },
);

export { puzzelHttpClient };
